import type { ThemeConfig } from "antd";

// Scoped Ant Design theme for the Member Profile V2 screen. Applied via a
// <ConfigProvider> wrapping only this screen, so the refreshed teal accent and
// tighter component metrics don't leak into the rest of the admin shell (the
// navy sider chrome is untouched). Font family is intentionally NOT overridden
// — we keep the admin app's established font and match only the type sizes /
// weights, per the handoff's font note.
export const FORTIUS_TEAL = "#0d7c73";

export const fortiusProfileTheme: ThemeConfig = {
    token: {
        colorPrimary: FORTIUS_TEAL,
        colorInfo: FORTIUS_TEAL,
        colorSuccess: "#1f8a5b",
        colorWarning: "#b7791f",
        colorError: "#c03a2b",
        colorTextBase: "#1f2a2e",
        colorBgLayout: "#f3f6f6",
        borderRadius: 8,
        borderRadiusLG: 12,
        controlHeight: 34,
        wireframe: false,
    },
    components: {
        Card: { borderRadiusLG: 12, paddingLG: 18, headerFontSize: 15 },
        Tabs: { titleFontSize: 14, horizontalItemGutter: 22 },
        Tag: { borderRadiusSM: 6 },
        Collapse: { headerPadding: "12px 14px", contentPadding: "4px 14px 14px" },
        Table: { headerBg: "#f6f9f9", headerColor: "#5b6b70", cellPaddingBlock: 9 },
        Statistic: { titleFontSize: 12 },
        Button: { fontWeight: 600 },
        Segmented: { itemSelectedBg: FORTIUS_TEAL, itemSelectedColor: "#fff" },
    },
};
